module.exports = __webpack_public_path__ + "img/Uri Kirstein.0628d653.jpg";